<section class="wrapper">
  <app-sidebar *ngIf="isLogIn && showSideBar && isUserModuleData"></app-sidebar>
  <main class="content-page" id="appMainContent" [ngClass]="{'marginNone': mainContentMargin}" >
    <div #LockedContent style="background-color: #f0f0f0 !important; display: flex; flex-direction: column; height: 100%;">
      <ng-container *ngIf="!showCanvas">
        <router-outlet *ngIf="showRouter"></router-outlet>
        <footer *ngIf="isLogIn && powerMaster && isUserModuleData">
          <div class="copyright">{{'Copyright' | translate}} © {{CopyrightYear}} {{'All rights reserved.' | translate}}</div>
          <div class="privacy-and-terms">
            <a translate [routerLink]="'/' + shareModel.urlPath.TermsAndConditions" target="_blank">Terms & Conditions</a>
            <a translate [routerLink]="'/' + shareModel.urlPath.PrivacyPolicy" target="_blank">Privacy Policy</a>
          </div>
        </footer>
        <footer *ngIf="isLogIn && !powerMaster && isUserModuleData && showSideBar">
          <div class="copyright">{{'Copyright' | translate}} © {{CopyrightYear}} {{'Cyber Power Systems, Inc.' | translate}} {{'All rights reserved.' | translate}}</div>
          <div class="privacy-and-terms">
            <a translate href="https://www.cyberpower.com/global/en/policy/terms" target="_blank">Terms & Conditions</a>
            <a translate href="https://www.cyberpower.com/global/en/policy/privacy" target="_blank">Privacy Policy</a>
          </div>
        </footer>
      </ng-container>
      <ng-container *ngIf="showCanvas">
        <div class="blur">
          <img class="responsive-image" [src]="canvasImg" *ngIf="canvasImg">
        </div>
      </ng-container>
    </div>
  </main>
  <ngx-ui-loader></ngx-ui-loader>
</section>
<p-toast [style]="{ marginTop: '70px'}"></p-toast>

<p-dialog [(visible)]="isLockDialogVisible" [modal]="true" [showHeader]="false" [blockScroll]="true" [style]="{'width': '650px'}" class="ConfirmDialog locked scrollDialog moreContentDialog" [baseZIndex]="6666" [maskStyleClass]="'lock-mask'">
  <div class="content-info center auth locked">
    <span class="fa-stack fa-lg">
      <i class="fa fa-circle fa-stack-2x"></i>
      <i class="fa fa-lock fa-stack-1x fa-inverse"></i>
    </span>
    <h5 translate>Locked</h5>
    <p translate>Due to an insufficient NPM balance, your PPC PRO service has been temporarily locked.</p>
    <div *ngIf="false">
      <p translate>Please contact your local distributor or the CyberPower team.</p>
      <div class="btnBox">
        <a target="_blank" href="https://www.cyberpower.com/global/en/contact/email" class="btn btn-danger">{{'Contact Us' | translate}}</a>
      </div>
    </div>
    <ng-container [ngSwitch]="proLock.AuthType">
      <p translate *ngSwitchCase="0">Please contact your local distributor or the CyberPower team.</p>
      <p translate *ngSwitchCase="1">Please purchase sufficient NPM to unlock your PPC PRO.</p>
      <p translate *ngSwitchCase="2">Please contact your main company's Account Manager.</p>
      <div *ngSwitchCase="1" class="imgBox">
        <h6>Company Management -> Pay by Credit Card -> One-Time Purchase</h6>
        <img src="/assets/images/img_pro_locked.png" class="dialog-lock-image">
      </div>
      <div class="btnBox">
        <a *ngSwitchCase="0" target="_blank" href="https://www.cyberpower.com/global/en/contact/email" class="btn btn-danger">{{'Contact Us' | translate}}</a>
        <a *ngSwitchCase="1" href="/management/pro/company" class="btn btn-danger">{{'Pay Now' | translate}}</a>
        <button *ngSwitchCase="2" type="button" pButton label="OK" class="ui-button-danger" (click)="logout()"></button>
      </div>
    </ng-container>
  </div>
</p-dialog>
